import { render, staticRenderFns } from "./WordStructureForm.vue?vue&type=template&id=3e4bb761&scoped=true&lang=pug&"
import script from "./WordStructureForm.vue?vue&type=script&lang=js&"
export * from "./WordStructureForm.vue?vue&type=script&lang=js&"
import style0 from "./WordStructureForm.vue?vue&type=style&index=0&id=3e4bb761&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4bb761",
  null
  
)

export default component.exports